module.exports = __webpack_public_path__ + "img/i-pinterest.21f79ef5.png";